import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the EmiPmiPaymentsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-emi-pmi-payments',
  templateUrl: 'emi-pmi-payments.html',
})
export class EmiPmiPaymentsPage {
  arrAccountSummary: any;
  

  constructor(public navCtrl: NavController, public navParams: NavParams,public events:Events) {
     
  }

  ionViewDidLoad() {
     
      this.ionSelected()
     
  }

  ionSelected(){
    //console.log("this.emiPemiInfo",this.navParams);
    this.arrAccountSummary=this.navParams.data.repaymentDetails.responseParameters;
    
    this.events.subscribe('tabsEventDataArrResponceEmiPEmi:created', (ress:any, time) => {
       
      console.log(ress,"this.ar");
       this.arrAccountSummary=ress.repaymentDetails.responseParameters;
       
       
      
      //console.log("getting account summary data",res.loanParameterDetail.responseParameters);
    })
     
  }
}



// WEBPACK FOOTER //
// ./src/pages/emi-pmi-payments/emi-pmi-payments.ts